<template>
  <layout>
    <div slot="content">
      <i-card title="管理员列表">
        <div slot="content">
          <el-table :data="adminUserList" :border="true">
            <el-table-column prop="username" label="管理员用户名"></el-table-column>
            <el-table-column prop="real_name" label="真实姓名"></el-table-column>
            <el-table-column prop="group_name" label="用户组"></el-table-column>
            <el-table-column label="状态" width="100">
              <div slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="mini">
                  {{ scope.row.status === 1 ? '启用' : '禁用' }}
                </el-tag>
              </div>
            </el-table-column>
            <el-table-column label="操作">
              <div slot-scope="scope">
                <el-button type="primary" size="mini" @click="edit(scope.row)" :disabled="scope.row.group_id === 1">编辑</el-button>
                <el-button
                  type="warning"
                  size="mini"
                  @click="switchStatus(scope.row)"
                  :disabled="scope.row.group_id === 1 || !isSuperAdmin">
                  {{ scope.row.status === 1 ? '禁用' : '启用' }}
                </el-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div slot="right-menu">
          <el-button type="success" size="medium" icon="el-icon-plus" @click="add">
            添加管理员
          </el-button>
        </div>
      </i-card>
      <el-dialog :visible.sync="showAddUser" title="添加管理员" width="450px">
        <el-form :model="fields" size="small" :rules="validateRules" label-width="80px">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="fields.username" :disabled="isEdit"></el-input>
          </el-form-item>
          <el-form-item label="真实姓名" prop="real_name">
            <el-input v-model="fields.real_name" autocomplete="false"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="fields.password" type="password"></el-input>
          </el-form-item>
          <el-form-item label="用户组" prop="group_id">
            <el-select v-model="fields.group_id" placeholder="请选择用户组" style="width: 100%">
              <el-option
                v-for="(item,index) in groups"
                :key="index"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="showAddUser = false">取消</el-button>
          <el-button type="primary" :loading="loading" @click="postUser">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
  export default {
    name: "admin_list",
    data: function () {
      return {
        adminUserList: [],
        showAddUser: false,
        isEdit: false,
        isSuperAdmin: false,
        fields: {
          username: '',
          real_name: '',
          password: '',
          group_id: ''
        },
        groups: [],
        validateRules: {
          username: [
            {required: true, message: '请输入用户名', trigger: 'blur'},
          ],
          real_name: [
            {required: true, message: '请输入真实姓名', trigger: 'blur'},
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'},
          ],
          group_id: [
            {required: true, message: '请选择用户组', trigger: 'blur'},
          ]
        },
        loading: false
      }
    },
    methods: {
      getGroupList: function () {
        this.$http.request('AdminGroupList').then(res => {
          this.groups = res.data;
        });
      },
      getAdminUserList: function () {
        this.$http.request('adminUserList').then(res => {
          this.adminUserList = res.data;
        });
      },
      postUser: function () {
        this.loading = true;
        this.$http.request('postAdminUser', this.fields).then(res => {
          this.loading = false;
          if (res.status === 'success') {
            this.showAddUser = false;
            this.getGroupList();
            this.getAdminUserList();
          }
        });
      },
      edit: function (user) {
        this.fields = user;
        this.showAddUser = true;
        this.isEdit = true;
      },
      add: function () {
        this.fields = {
          username: '',
          real_name: '',
          password: '',
          group_id: ''
        };
        this.showAddUser = true;
        this.isEdit = false;
      },
      switchStatus: function (user) {
        this.$confirm(`确认要${user.status === 1 ? '禁用' : '启用'}该管理员账号吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.request('switchAdminStatus', {admin_user_id: user.id}).then(res => {
            if (res.status === 'success') {
              this.$message.success(res.message);
              this.getAdminUserList();
            } else {
              this.$message.error(res.message);
            }
          });
        }).catch(() => {});
      }
    },
    created: function () {
      this.getGroupList();
      this.getAdminUserList();
      this.$http.request('isSuperAdmin').then(res => {
        this.isSuperAdmin = res.data.is_super_admin;
      });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/admin/admin_list.vue